<div class="modal fade show" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" *ngIf='item'> {{ 'agendaCase.editSurgery' | translate }} </h4>
                <h4 class="modal-title" *ngIf='!item'> {{ 'agendaCase.addSurgery' | translate }} </h4>

                <button type="button" class="close" aria-label="Close" (click)="closePop()">
                    <span>&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <form [formGroup]="formGroup">

                    <div class="form-group">
                        <mat-form-field>
                            <mat-label>{{ 'agendaCase.SNumber' | translate }}</mat-label>
                            <input matInput formControlName="sNumber" maxlength="250">

                            <mat-error *ngIf="hasError('sNumber', 'required')">
                                {{ 'meetings.Required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="form-group">
                        <mat-form-field>
                            <mat-label>{{ 'agendaCase.DoctorName' | translate }}</mat-label>
                            <input matInput formControlName="doctorName" maxlength="250">

                            <mat-error *ngIf="hasError('doctorName', 'required')">
                                {{ 'meetings.Required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="form-group">
                        <mat-form-field>
                            <mat-label> {{ 'agendaCase.sdate' | translate }}</mat-label>
                            <input matInput [max]="maxDate" [matDatepicker]="picker" readonly formControlName="sdate">
                            <mat-icon matDatepickerToggleIcon *ngIf="formGroup.get('sdate').value"
                            (click)="formGroup.get('sdate').setValue('')">clear</mat-icon>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>

                            <mat-error *ngIf="hasError('sdate', 'required')">
                                {{ 'meetings.Required' | translate }}
                            </mat-error>
                            <mat-error
                                *ngIf="hasError('sdate', 'matDatepickerMin') || hasError('sdate', 'matDatepickerMax')">
                                {{ 'messages.dateInvalid' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="form-group">
                        <mat-form-field>
                            <mat-label>{{ 'agendaCase.SurgeryType' | translate }}</mat-label>
                            <mat-select formControlName="clinicTypeLookupId">
                                <mat-option></mat-option>
                                <mat-option *ngFor="let clinic of clinicalTypes" [value]="clinic.id">
                                    <ng-container *ngIf="language == 'ar'">
                                        {{clinic.title_Ar}}
                                    </ng-container>
                                    <ng-container *ngIf="language == 'en'">
                                        {{clinic.title_En}}
                                    </ng-container>
                                </mat-option>
                            </mat-select>

                            <mat-error *ngIf="hasError('clinicTypeLookupId', 'required')">
                                {{ 'meetings.Required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="form-group my-5">
                        <label class="mb-2">{{ 'meetings.Attachments' | translate }}</label>
                        <app-file-manager class="one-col" [files]='files' [maxFileSize]='25'
                            [allowedExt]="['PPTX', 'PPT', 'XLSX', 'PDF']" (deletedFilesList)='deletedFiles = $event'
                            (selectedFiles)="files = $event"></app-file-manager>
                    </div>
                    <div class="modal-btns">
                        <button type="reset" class="close closebtn" aria-label="Close" (click)="closePop()">
                            {{ 'meetings.DiscardChanges' | translate }}
                        </button>
                        <button mat-raised-button class="btn customBtn" (click)="saveItem()" [disabled]="loading"
                            [ngClass]="{ 'loading': loading }">
                            {{ 'meetings.Save' | translate }}
                        </button>
                    </div>

                </form>
            </div>
        </div>
    </div>
